import { ServiceNames } from './service-name.js';

const ITEM_NAME_TO_SERVICE_NAME = {
    toolbarItems: ServiceNames.TOOLBAR,
    mobileToolbarItems: ServiceNames.MOBILE_TOOLBAR,
    menuItems: ServiceNames.MENU,
    mobileMenuItems: ServiceNames.MOBILE_MENU,
    statusbarItems: ServiceNames.STATUSBAR,
    contextMenuItems: ServiceNames.CONTEXT_MENU,
    mobileContextMenuItems: ServiceNames.MOBILE_CONTEXT_MENU,
    keymapConfigs: ServiceNames.KEYMAP,
    titlebarItems: ServiceNames.TITLEBAR,
    mobileTitlebarItems: ServiceNames.MOBILE_TITLEBAR,
    mobileActionButtons: ServiceNames.MOBILE_ACTION_BUTTON,
};
const SERVICE_NAME_TO_ITEM_NAME = {
    [ServiceNames.MOBILE_MENU]: 'mobileMenuItems',
    [ServiceNames.MENU]: 'menuItems',
    [ServiceNames.TOOLBAR]: 'toolbarItems',
    [ServiceNames.MOBILE_TOOLBAR]: 'mobileToolbarItems',
    [ServiceNames.CONTEXT_MENU]: 'contextMenuItems',
    [ServiceNames.MOBILE_CONTEXT_MENU]: 'mobileContextMenuItems',
    [ServiceNames.TITLEBAR]: 'titlebarItems',
    [ServiceNames.MOBILE_TITLEBAR]: 'mobileTitlebarItems',
    [ServiceNames.STATUSBAR]: 'statusbarItems',
    [ServiceNames.MOBILE_ACTION_BUTTON]: 'mobileActionButtons',
    [ServiceNames.KEYMAP]: 'keymapConfigs',
};

export { ITEM_NAME_TO_SERVICE_NAME, SERVICE_NAME_TO_ITEM_NAME };
//# sourceMappingURL=ui-service-item-name.js.map
